module.exports = __webpack_public_path__ + "img/arrow-select-2.eb003e9b.svg";